export default __webpack_public_path__ + "static/media/close-round-fill.6b900f5e.svg";